import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

function PageNotFound() {
  const { t } = useTranslation();
  return (
    <Typography component="p" variant="lead">
      {t("pageNotFound.header.title.text")}
    </Typography>
  );
}

export default PageNotFound;
